import React, { FC } from 'react'

import { ampli } from '@Analytics/ampli'
import { Button } from '@Components/Button'
import { wishListStateManager } from '@Domains/WishList/StateManager'
import { useTranslation } from '@Globals/Translations'

import styles from './WishList.module.scss'

interface WishListHeaderProps {
  count: number
}

const WishListHeader: FC<WishListHeaderProps> = ({ count }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.header}>
      <h1>{t('cms:MY_WISH_LIST')}</h1>
      {t('products:CP_X_PRODUCTS', '{{arg1}} products', { arg1: count })}
      <Button
        color="grey"
        onClick={(event) => {
          event.preventDefault()
          event.stopPropagation()

          ampli.wishListClear()
          ampli.wishlistUpdated({ product_ids: [] })

          wishListStateManager.clear()
          window.location.reload()
        }}
        size="small"
        width="auto"
      >
        {t('cms:CLEAR_MY_LIST')}
      </Button>
    </div>
  )
}

export default WishListHeader
